<template lang="pug">
include ./../../vuek/mixins.pug

+b.the-header
  +e.left
    +e.logo
      +e.A.link(href="https://ti-ukraine.org/" target="_blanck")
        +e.IMG.logo(src="static/img/ti-logo.svg")
    +e.header
      +e.H1.title {{content.title}}
  +e.right
    t-lng
</template>

<script>
import { mapGetters } from 'vuex';

import TLng from '@/components/TLng/TLng';

export default {
  name: 'the-header',

  computed: {
    ...mapGetters({
      content: 'getContent',
    }),
  },

  components: {
    TLng,
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.the-header {
  display: flex;
  color: $color-white;
  text-align: left;
  justify-content: space-between;
  margin-top: 72px;

  &__left {
    display: flex;
  }

  &__logo {
    margin-top: 5px;
    margin-right: 20px;
    height: 30px;
  }

  &__right {
    padding-top: 10px;
  }

  &__title {
    margin: 0;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader/TheHeader.vue